import { Component, OnInit, Input, Output, ViewEncapsulation, EventEmitter, OnDestroy } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { AppSettings } from '../../../../app.settings';
import { Settings } from '../../../../app.settings.model';
import { MenuService } from '../menu.service';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-vertical-menu',
    templateUrl: './vertical-menu.component.html',
    styleUrls: ['./vertical-menu.component.scss'],
    encapsulation: ViewEncapsulation.None,
    providers: [MenuService]
})
export class VerticalMenuComponent implements OnInit, OnDestroy
{
    private subscriptions: Subscription[] = [];
    public enableIntegrationServer: boolean = false;

    @Input('menuItems') menuItems;
    @Input('menuParentId') menuParentId;
    @Output() onClickMenuItem: EventEmitter<any> = new EventEmitter<any>();
    parentMenu: Array<any>;
    public settings: Settings;
    constructor(public appSettings: AppSettings, public menuService: MenuService, public router: Router)
    {
        this.settings = this.appSettings.settings;
    }

    ngOnInit()
    {
        this.subscriptions.push(this.menuService.getEnableIntegrationServer().subscribe(result =>
        {
            this.enableIntegrationServer = result;
            if (this.enableIntegrationServer){
                this.menuItems.forEach(menu => {
                    if(menu.routerLink === '/holiday' || menu.routerLink === '/business-hours' || menu.routerLink === '/date-time-rule'){
                        menu.enable = false;
                    }
                });
            }
        }));
        this.parentMenu = this.menuItems.filter(item => item.parentId == this.menuParentId);
    }

  

    ngOnChanges()
    {
        // react on changes
        // so that the component can be rerendered
        this.parentMenu = this.menuItems.filter(item => item.parentId == this.menuParentId);
    }

    ngAfterViewInit()
    {
        this.subscriptions.push(this.router.events.subscribe(event =>
        {
            if (event instanceof NavigationEnd)
            {
                if (this.settings.fixedHeader)
                {
                    let mainContent = document.getElementById('main-content');
                    if (mainContent)
                    {
                        mainContent.scrollTop = 0;
                    }
                }
                else
                {
                    document.getElementsByClassName('mat-drawer-content')[0].scrollTop = 0;
                }
            }
        }));
    }

    onClick(menuId)
    {
        this.menuService.toggleMenuItem(menuId);
        this.menuService.closeOtherSubMenus(this.menuItems, menuId);
        this.onClickMenuItem.emit(menuId);
    }

    ngOnDestroy()
    {
        this.subscriptions.forEach(s => s.unsubscribe());
    }
}
